import { combineReducers, createStore } from "redux";
import { globalReducer } from "./reducers/globalReducer";
import { videoSavedReducer } from "./reducers/videoUploadReducer";

const allReducer = combineReducers({
  global: globalReducer,
  videoSaved: videoSavedReducer,
});

const store = createStore(allReducer);
export default store;
